import React from 'react';

const IMG = {
  hero: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?q=80&w=2680&auto=format&fit=crop',
};

const ServicesHero: React.FC = () => (
  <section className="relative min-h-screen flex items-center overflow-hidden">
    <img src={IMG.hero} alt="Operating room surgery lights" className="absolute inset-0 w-full h-full object-cover opacity-60 mix-blend-overlay" />
    <div className="absolute inset-0 bg-primary/90" />
    <div className="container-main relative z-10 text-center w-full">
      <span className="inline-block bg-white/10 border border-white/20 text-white/80 text-xs uppercase tracking-widest font-semibold px-4 py-1.5 rounded-full mb-4 mt-20 md:mt-0">
        What We Offer
      </span>
      <h1 className="text-5xl md:text-6xl font-extrabold text-white mt-3 mb-5">Our Services</h1>
      <p className="text-white/70 text-lg max-w-2xl mx-auto leading-relaxed">
        Excellence in medical supplies and equipment in Africa. Full-scale quality provider of equipment,
        services, reagents and water testing equipment for laboratory and hospital industries.
      </p>
    </div>
  </section>
);

export default ServicesHero;
